import React from 'react';

function PlayerSeasonSelectors({
  isPlayerSeasonExpanded,
  setIsPlayerSeasonExpanded,
  players,
  seasons,
  activePlayerId,
  activeSeasonId,
  changeActivePlayer,
  changeActiveSeason
}) {
  return (
    <section style={{ 
      background: "#fff", 
      border: "1px solid var(--border)", 
      borderRadius: "12px", 
      padding: "24px", 
      marginBottom: "24px" 
    }}>
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: isPlayerSeasonExpanded ? "20px" : "0",
        cursor: "pointer"
      }}
      onClick={() => setIsPlayerSeasonExpanded(!isPlayerSeasonExpanded)}
      >
        <h2 style={{ 
          fontSize: "20px", 
          fontWeight: "600", 
          margin: "0", 
          color: "var(--text)" 
        }}>
          Player & Season
        </h2>
        <button
          type="button"
          style={{
            background: "transparent",
            border: "none",
            color: "var(--muted)",
            cursor: "pointer",
            fontSize: "16px",
            padding: "4px",
            borderRadius: "4px",
            transition: "all 0.2s ease",
            transform: isPlayerSeasonExpanded ? "rotate(180deg)" : "rotate(0deg)"
          }}
          title={isPlayerSeasonExpanded ? "Collapse" : "Expand"}
        >
          ▼
        </button>
      </div>
      
      {isPlayerSeasonExpanded && (
        <>
          <div style={{ 
            display: "grid", 
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", 
            gap: "16px" 
          }}>
            <div>
              <label style={{ 
                display: "block", 
                fontSize: "12px", 
                fontWeight: "500", 
                color: "var(--text)", 
                marginBottom: "6px" 
              }}>
                Player
              </label>
              <select
                className="input"
                value={activePlayerId || ""}
                onChange={(e) => changeActivePlayer(e.target.value)}
                style={{ width: "100%" }}
              >
                {players.length === 0 && <option value="" disabled>(no players)</option>}
                {players.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label style={{ 
                display: "block", 
                fontSize: "12px", 
                fontWeight: "500", 
                color: "var(--text)", 
                marginBottom: "6px" 
              }}>
                Season
              </label>
              <select
                className="input"
                value={activeSeasonId || ""}
                onChange={(e) => changeActiveSeason(e.target.value)}
                disabled={!activePlayerId || seasons.length === 0}
                style={{ width: "100%" }}
              >
                {seasons.length === 0 && <option value="" disabled>(no seasons)</option>}
                {seasons.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name}
                    {s.year ? ` (${s.year})` : ""}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </>
      )}
    </section>
  );
}

export default PlayerSeasonSelectors;